export const environment = {
	production: false,
	apiUrl: 'https://dev-pix-omni-ib-api.omni.com.br/v1/',
	apiIB: 'https://dev-ib-api.omni.com.br/',
	bankBaseUrlV2: 'https://dev-ib-api.omni.com.br/coc/api',
};

export const endpoints = {
	auth: {
		oauth: environment.apiIB + 'auth/oauth/token',
	},

	basicOAuth: 'b21uaWRpZ2l0YWw6c2VjcmV0',

	utils: {
		whiteLabel: environment.apiUrl + 'v1/utils/white-label/',
		config: environment.apiUrl + 'v1/utils/configs',
		push: {
			mensagem: environment.apiUrl + 'v1/utils/push/mensagem'
		},
		banks: environment.apiUrl + 'v1/utils/bancos',
		states: environment.apiUrl + 'v1/utils/estados',
		cities: environment.apiUrl + 'v1/utils/cidades',
		faqs: environment.apiUrl + 'v1/utils/faqs',
		addHelpDesk: environment.apiUrl + 'v1/utils/abrir-chamado',
		address: environment.apiUrl + 'v1/utils/enderecos',
		terms: environment.apiUrl + 'v1/utils/termos',
		cnae: environment.apiUrl + 'v1/utils/cnae',
		maritalStatus: environment.apiUrl + 'v1/utils/estados-civis',
		addressSearch: environment.apiUrl + 'v1/utils/endereco-consulta',
		nationality: environment.apiUrl + 'v1/utils/nacionalidades',
		currentTimeServer: environment.apiUrl + 'v1/utils/data-hora'
	},

	receipts: {
		all: environment.apiUrl + 'v1/usuarios/logado/contas/atual/comprovantes',
		allV2: environment.apiUrl + 'v2/usuarios/logado/contas/atual/comprovantes',
		detail: environment.apiUrl + 'v1/usuarios/logado/contas/atual/comprovantes/',
		sendEmail: environment.apiUrl + 'v1/usuarios/logado/contas/atual/comprovantes/'
	},

	consultants: environment.apiUrl + 'v1/usuarios/logado/contas/atual/consultadores/',

	dateBlockValidation: environment.apiUrl + 'v2/data-bloqueio/validar',

	attendant: {
		login: environment.apiUrl + 'v1/utils/usuario/atendimento',
		clientAccounts: environment.apiUrl + 'v1/usuarios/logado/listar/adesoes/',
	},

	accounts: {
		users: environment.apiUrl + 'v1/usuarios/',
		login: environment.apiUrl + 'v1/usuarios/login',
		selection: environment.apiUrl + 'v1/usuarios/logado/contas',
		evolution: environment.apiUrl + 'v1/usuarios/logado/contas/atual/evolucao/',
		releases: environment.apiUrl + 'v1/usuarios/logado/contas/atual/lancamentos',
		notifications: environment.apiUrl + 'v1/usuarios/logado/contas/atual/notificacoes/',
		terms: '/termos/aceite',
		balance: environment.apiUrl + 'v2/usuarios/logado/contas/atual/saldo/',
		limits: environment.apiUrl + 'v2/limites',
		limiteGlobal: environment.apiUrl + 'v1/limite-global',
		validateTransactionPassword: environment.apiUrl + 'v1/usuarios/logado/senha/transacao/validacao',
		updateTransactionPassword: environment.apiUrl + 'v1/usuarios/logado/senha/transacao',
		defineTransactionPassword: environment.apiUrl + 'v1/usuarios/senha/transacao',
		rename: environment.apiUrl + 'v1/usuarios/logado/contas/atual/nome',
		updateAccessPassword: environment.apiUrl + 'v1/usuarios/logado/senha/acesso',
		defineAccessPassword: environment.apiUrl + 'v1/usuarios/senha/acesso',
		redefineAccessPassword: environment.apiUrl + 'v1/usuarios/senha/acesso/redefinicao',
		positiveId: '/identificacao-positiva',
		securityQuestions: environment.apiUrl + 'v1/usuarios/perguntas',
		ibPositiveId: environment.apiIB + 'auth/api/forgot-password/positive-identification',
		ibSecurityQuestions: environment.apiIB + 'auth/api/forgot-password/security-questions',
		sms: '/sms/codigo',
		enviarSms: environment.apiUrl + 'v1/usuarios/sms/codigo',
		tips: environment.apiUrl + 'v1/usuarios/logado/contas/atual/mensagens/',
		tokenSMS: environment.apiUrl + 'v1/usuarios/logado/token',
		reportIncomeYears: environment.apiUrl + 'v1/usuarios/logado/contas/atual/informes/anos',
		reportIncome: environment.apiUrl + 'v1/usuarios/logado/contas/atual/informes'
	},

	transactions: {
		all: environment.apiUrl + 'v2/usuarios/logado/contas/atual/transacoes',
		detail: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/',
		detailPackages: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pacotes/detalhes/',
		processing: environment.apiUrl + 'v2/usuarios/logado/contas/atual/transacoes/processamento',
	},

	transfers: {
		otherBanks: environment.apiUrl + 'v2/usuarios/logado/contas/atual/transferencias/',
		otherBanksV3: environment.apiUrl + 'v3/usuarios/logado/contas/atual/transferencias/',
		betweenAccounts: environment.apiUrl + 'v2/usuarios/logado/contas/atual/transferencias/entreContas/',
		betweenAccountsV3: environment.apiUrl + 'v3/usuarios/logado/contas/atual/transferencias/entreContas/',
	},

	benefactors: {
		all: environment.apiUrl + 'v1/usuarios/logado/contas/atual/favorecidos'
	},

	confirmation: '/confirmacao',

	payments: {
		ticket: environment.apiUrl + 'v1/usuarios/logado/contas/atual/pagamentos/boleto/',
		ticketV2: environment.apiUrl + 'v2/usuarios/logado/contas/atual/pagamentos/boleto/',
		covenant: environment.apiUrl + 'v2/usuarios/logado/contas/atual/pagamentos/convenio/',
		confirm: environment.apiUrl + 'v1/usuarios/logado/contas/atual/pagamentos/',
		confirmCip: environment.apiUrl + 'v2/usuarios/logado/contas/atual/pagamentos/',
		cipQuery: environment.apiUrl + 'v2/usuarios/logado/contas/atual/pagamentos/consulta/cip',
		covenantQuery: environment.apiUrl + 'v2/usuarios/logado/contas/atual/pagamentos/consulta/convenio'
	},

	deposits: {
		ticket: environment.apiUrl + 'v1/usuarios/logado/contas/atual/boleto',
		pdf: environment.apiUrl + 'v1/usuarios/logado/contas/atual/boleto/gerar',
		sendEmail: environment.apiUrl + 'v1/usuarios/logado/contas/atual/boleto/email',
		parameters: environment.apiUrl + 'v1/usuarios/logado/contas/atual/boletos/parametros',
	},

	investments: {
		all: environment.apiUrl + 'v1/usuarios/logado/contas/atual/investimentos/',
		repurchasePartial: environment.apiIB + 'renda-fixa/api/repurchase/partial',
		repurchaseTotal: environment.apiIB + 'renda-fixa/api/repurchase/total',
		deadlines: environment.apiUrl + 'v1/usuarios/logado/contas/atual/investimentos/prazos',
		simulation: environment.apiUrl + 'v1/usuarios/logado/contas/atual/investimentos/simulacao/',
		applicationPreFixed: environment.apiIB + 'renda-fixa/api/investment/fixed-rate',
		applicationPosFixed: environment.apiIB + 'renda-fixa/api/investment/floating-rate',
	},

	packagesBankCharges: {
		currentPackage: environment.apiUrl + 'v1/usuarios/logado/contas/atual/pacotes/contratos',
		extract: environment.apiUrl + 'v1/usuarios/logado/contas/atual/pacotes/extratos',
		otherPackages: environment.apiUrl + 'v1/usuarios/logado/contas/atual/pacotes',
		otherPackagesDetails: environment.apiUrl + 'v1/usuarios/logado/contas/atual/pacotes',
		hire: environment.apiUrl + 'v1/usuarios/logado/contas/atual/pacotes/contratos',
		term: environment.apiUrl + 'v1/usuarios/logado/contas/atual/pacotes'
	},

	creditCard: {
		status: environment.apiUrl + 'v1/usuarios/logado/cartoes/consultarStatus',
		enable: environment.apiUrl + 'v1/usuarios/logado/cartoes/habilitar',
		terms: environment.apiUrl + 'v1/usuarios/logado/cartoes/consultaTermos',
		imgs: environment.apiUrl + 'v1/usuarios/logado/cartoes/consultaImagens',
	},

	cards: {
		updatePassword: environment.apiUrl + 'v1/usuarios/logado/cartoes/alterarSenha',
		list: environment.apiUrl + 'v1/usuarios/logado/cartoes/ListarCartoes',
		unlockCard: environment.apiUrl + 'v1/usuarios/logado/cartoes/desbloquear',
		blockCard: environment.apiUrl + 'v1/usuarios/logado/cartoes/bloquear'
	},

	collection: {
		base: environment.apiUrl + 'v1/usuarios/logado/contas/atual/sacados',
	},

	billet: {
		base: environment.apiUrl + 'v1/usuarios/logado/contas/atual/boletos',
		parameters: environment.apiUrl + 'v1/usuarios/logado/contas/atual/boletos/parametros',
	},

	closeAccount: {
		terms: environment.apiUrl + 'v1/encerramento/termos',
		resolution: environment.apiUrl + 'v1/encerramento/resolucao',
		situation: environment.apiUrl + 'v1/encerramento/situacao',
		request: environment.apiUrl + 'v1/encerramento/solicitacao',
		reasons: environment.apiUrl + 'v1/encerramento/motivos',
	},

	pix: {
		notifications: environment.apiUrl + 'v1/usuarios/logado/contas/notificacoes/pix',
		keys: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/chaves',
		keysAccount: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/chaves/contas',
		keysFavorite: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/chaves/favorecidas',
		keysFavoriteV2: environment.apiUrl + 'v2/usuarios/logado/contas/atual/transacoes/pix/chaves/favorecidas',
		keysMain: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/chaves/principal',
		keysValidate: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/chaves/validar',
		qrcode: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/qrcode',
		qrcodeAccount: environment.apiUrl + 'v2/usuarios/logado/contas/atual/transacoes/pix/contas/qrcode',
		qrCodeWithdrawChange: environment.apiUrl + '/v2/usuarios/logado/contas/atual/transacoes/pix/contas/qrcode',
		claim: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/chaves/reivindicacoes',
		claimResponse: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/chaves/reivindicacoes/resposta',
		claimReceive: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/chaves/reivindicacoes/recebidas/pendentes',
		claimRequest: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/chaves/reivindicacoes/enviadas/pendentes',
		transfer: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/transferir',
		refund: environment.apiUrl + 'v1/usuarios/logado/contas/atual/transacoes/pix/devolucao',
		available: environment.apiUrl + 'v1/usuarios/logado/contas/atual/pix/disponivel',
		limits: environment.apiUrl + 'v2/limites',
		trasactionWithdrawChange: environment.apiUrl + 'v2/usuarios/logado/contas/atual/transacoes/pix/transferenciapixsaquetroco',
	},

	bankStatement: {
		general: environment.apiUrl + 'v1/extrato/consulta',
		generalV2: environment.apiUrl + 'v2/extrato',
		pix: environment.apiUrl + 'v1/extrato/consulta-pix',
		detail: environment.apiUrl + 'v1/extrato/consulta-detalhes',
	},

	updateAccunt: {
		texte: environment.apiUrl + 'teste',
		docTypes: environment.apiUrl + 'v1/proposta-atualizacao-cadastral/documentos/tipos',
		docs: environment.apiUrl + 'v1/proposta-atualizacao-cadastral/documentos',
		submit: environment.apiUrl + 'v1/proposta-atualizacao-cadastral/enviar-para-analise',
		timeline: environment.apiUrl + 'v1/proposta-atualizacao-cadastral/linha-do-tempo',
		new: environment.apiUrl + 'v1/proposta-atualizacao-cadastral/nova-proposta',
		proposal: environment.apiUrl + 'v1/proposta-atualizacao-cadastral/proposta',
		phone: environment.apiUrl + 'v1/proposta-atualizacao-cadastral/responsavel/telefone',
		checkCpf: environment.apiUrl + 'v1/proposta-atualizacao-cadastral/responsavel/conferencia',
		responsible: environment.apiUrl + 'v1/proposta-atualizacao-cadastral/responsavel',
		pendency: environment.apiUrl + 'v1/proposta-atualizacao-cadastral/pendencia',
	},

	limits: {
		getLimits: environment.apiUrl + 'v2/limites'
	},

	deviceManagement: {
		getRegisteredDevice: environment.apiUrl + 'v1/registered-device'
	},

	analytics: {
		access: environment.bankBaseUrlV2 + '/contabil-acesso',
	}
};



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/environments/environment.ts